import { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as Email } from "../../../assets/img/icon/email_black_24dp.svg";
import { ReactComponent as Lock } from "../../../assets/img/icon/lock_black_24dp.svg";
import { ReactComponent as People } from "../../../assets/img/icon/people_black_24dp.svg";
import { ReactComponent as Person } from "../../../assets/img/icon/person_black_24dp.svg";
import { ReactComponent as VerifiedUser } from "../../../assets/img/icon/verified_user_black_24dp.svg";
import { ReactComponent as Visibility } from "../../../assets/img/icon/visibility_black_24dp.svg";
import { ReactComponent as VisibilityOff } from "../../../assets/img/icon/visibility_off_black_24dp.svg";
import { ReactComponent as WorkBlack } from "../../../assets/img/icon/work_black_24dp.svg";
import Respinos from "../../../assets/img/logo/logomd.png";
import { COLOR } from "../../../config/constant";
import { postUser } from "../../../services/httpService/userRequest";
import {
  accountSetupValidator,
  signUpValidator,
} from "../../../validators/SignupValidator";
import {
  updatePatientValidator,
} from "../../../validators/PatientValidator";
import { GlobalContext } from "../../contexts/globalContext";
import Alert from "../../ui/atoms/Alert/Alert";
import Button from "../../ui/atoms/Button/Button";
import HeroLogin from "../../ui/organisms/HeroLogin/HeroLogin";
import { ReactComponent as Wave } from "../../../assets/img/background/wave.svg";
import { ReactComponent as Wave2 } from "../../../assets/img/background/wave-2.svg";
import { ReactComponent as Wave3 } from "../../../assets/img/background/wave-3.svg";
import InputText from "../../ui/atoms/InputText/InputText";
import { VAR_LIMIT } from "../../../config/constant";
import { getDateFormat } from "../../../helpers/helper";



const Signup = () => {
  let minDate = new Date();
  minDate = minDate.setFullYear(minDate.getFullYear() - VAR_LIMIT.age.max);
  minDate = getDateFormat(minDate);

  const maxDate = getDateFormat(new Date());
  const [hidden, setHidden] = useState(true);
  const [sharedState, dispatch] = useContext(GlobalContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(-1);
  const [isPatient, setIsPatient] = useState(false);
  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
    role: "health worker",
    strNumber: "",
    workingPlace: "",
  });

  const [state2, setState2] = useState({
    name: "",
    email: "",
    password: "",
    sex: "pria",
    height: 0,
    weight: 0,
    dateOfBirth: ""
  });

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "email already taken":
        message = "Email telah digunakan oleh orang lain";
        break;
      case "you already asked to join recently. check the email to complete registration":
        message =
          "Akun ini telah didaftarkan, silakan periksa email untuk menyelesaikan pendaftaran.";
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const handleSignup = async () => {
    try {
      const { error } = await signUpValidator({
        strNumber: state.strNumber,
        workingPlace: state.workingPlace,
      });
      if (error) throw new Error(error.details[0].message);

      setLoading(true);
      setHidden(true);
      await postUser({
        name: state.name,
        password: state.password,
        email: state.email,
        role: state.role,
        workingPlace: state.workingPlace,
        strNumber: state.strNumber,
      });
      setLoading(false);
      dispatch("alert", {
        show: true,
        type: "success",
        message:
          "Akun telah dibuat. Silakan periksa email untuk menyelesaikan proses registrasi.",
      });
      history.push("/login");
    } catch (error) {
      const message = generateErrorMessage(error);
      dispatch("alert", {
        show: true,
        type: "warning",
        message: message,
      });
      setLoading(false);
    }
  };

  const handleSignup2 = async () => {
    try {
      const { error } = await updatePatientValidator({
        dateOfBirth: state2.dateOfBirth,
        weight: state2.weight,
        height: state2.height
      });
      if (error) throw new Error(error.details[0].message);

      setLoading(true);
      setHidden(true);
      await postUser({
        name: state.name,
        password: state.password,
        email: state.email,
        role: "patient",
        // workingPlace: "patient",
        // strNumber: "1234",
        dateOfBirth: state2.dateOfBirth,
        weight: state2.weight,
        height: state2.height,
        isMale: state2.sex === "Pria",
      });
      setLoading(false);
      dispatch("alert", {
        show: true,
        type: "success",
        message:
          "Akun telah dibuat. Silakan periksa email untuk menyelesaikan proses registrasi.",
      });
      history.push("/login");
    } catch (error) {
      const message = generateErrorMessage(error);
      dispatch("alert", {
        show: true,
        type: "warning",
        message: message,
      });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setState2((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const hideAlert = () => {
    dispatch("alert", { show: false });
  };

  const handleNext = async (isPatient) => {
    if (step === 0) {
      setIsPatient(isPatient);
      setStep(1);
      return;
    }
    try {
      const { error } = await accountSetupValidator({
        name: state.name,
        email: state.email,
        password: state.password,
      });
      if (error) throw new Error(error.details[0].message);
      setStep(2);
    } catch (error) {
      dispatch("alert", {
        show: true,
        type: "warning",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    setStep(0);
    return () => {
      setStep(-1);
    }
  }, []);

  return (
    <div
      className="flex w-full min-h-screen"
      style={{ color: COLOR.DARK, backgroundColor: COLOR.WHITESMOKE }}
    >
      <Alert data={sharedState.alert} handleClose={hideAlert} />
      <section className="w-full lg:w-112 flex-shrink-0 px-5 py-2 bg-white shadow-lg relative overflow-hidden">
        <div className="lg:hidden absolute inset-x-0 top-0 sm:-top-4 md:-top-12 lg:top-0">
          <Wave className="transform w-full" />
        </div>
        <div className="lg:hidden absolute inset-x-0 top-0 sm:-top-4 md:-top-12 lg:top-0">
          <Wave2 className="transform w-full rotate-180 " />
        </div>
        <div className="lg:hidden absolute inset-x-0 -bottom-2 sm:-bottom-8 md:-bottom-12  lg:bottom-0">
          <Wave3 className="transform w-full" />
        </div>
        <div className="lg:hidden absolute inset-x-0 -bottom-2 sm:-bottom-8 md:-bottom-12  lg:bottom-0">
          <Wave2 className="transform w-full" />
        </div>

        <div className="max-w-md mx-auto ">
          <div className="mt-16 md:mt-24 xl:mt-20">
            <img src={Respinos} alt="" className="h-10" />
          </div>

          <div className={(step === 0 ? "h-0" : "") + " relative duration-500 ease-in-out " + (step > 0
            ? "opacity-100 left-0 z-10"
            : "opacity-0  -left-5 z-0")}>

            <p className="hidden sm:block mt-6">
              Isi form berikut untuk mendapatkan akses Respinos
            </p>
            {/* STEP */}
            <div className="flex space-x-5 mt-8 sm:mt-3">
              <div
                className={"flex space-x-1 " + (step === 1 ? "" : "opacity-30")}
              >
                <div
                  className="w-6 h-6 rounded-full bg-secondary text-white text-center mx-auto"
                  style={{ lineHeight: "1.5rem" }}
                >
                  1
                </div>
                <div>Account Setup</div>
              </div>

              <div
                className={"flex space-x-1 " + (step === 2 ? "" : "opacity-30")}
              >
                <div
                  className="w-6 h-6 rounded-full bg-secondary text-white text-center mx-auto"
                  style={{ lineHeight: "1.5rem" }}
                >
                  2
                </div>
                <div>Personal Detail</div>
              </div>
            </div>

          </div>





          {/* FORM */}
          <form
            className="relative"
            style={{ minHeight: "20rem" }}
            autoComplete="off"
          >
            {/* STEP 0 */}

            <div
              className={
                "w-full absolute  transition-all duration-500 ease-in-out " +
                (step === 0
                  ? "opacity-100 left-0 z-10"
                  : "opacity-0  -left-5 z-0")
              }
            >
              <div className=" mt-0">
                <p >Apakah anda pasien atau tenaga kesehatan ?</p>
              </div>

              <div className="mt-8 ">
                <Button
                  className={
                    "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 " +
                    (loading ? "cursor-wait" : "")
                  }
                  handleClick={() => handleNext(true)}
                  disabled={loading}
                >
                  Pasien
                </Button>
              </div>

              <div className="mt-3">
                <Button
                  className={
                    "tracking-widest w-full  bg-primary text-white rounded-lg px-3 py-2 " +
                    (loading ? "cursor-wait" : "")
                  }
                  handleClick={() => handleNext(false)}
                  disabled={loading}
                >
                  Tenaga Kesehatan
                </Button>
              </div>

              <div className="mt-3 ">
                <p className="text-sm ">
                  Sudah punya akun?
                  <Link to="/login">
                    <span className="ml-1 text-primary cursor-pointer">
                      Login Sekarang
                    </span>
                  </Link>
                </p>
              </div>
              <br />
            </div>
            {/* STEP 1 */}
            <div
              className={
                "w-full absolute transition-all duration-500 ease-in-out " +
                (step === 1
                  ? "opacity-100 left-0 z-10"
                  : "opacity-0  -left-5 z-0")
              }
            >
              {/* NAME */}
              <div className="mt-2">
                <div className="text-sm text-primary text-opacity-70">Nama</div>
                <div className="relative">
                  <Person className="absolute top-1.5 left-2" fill="white" />
                  <input
                    type="text"
                    className={
                      "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                    }
                    name="name"
                    value={state.name}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              {/* EMAIL */}
              <div className="mt-2">
                <div className="text-sm text-primary text-opacity-70">
                  Email
                </div>
                <div className="relative">
                  <Email className="absolute top-1.5 left-2" fill="white" />
                  <input
                    type="text"
                    className={
                      "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                    }
                    name="email"
                    autoComplete={"new-password"}
                    value={state.email}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              {/* PASSWORD */}
              <div className="mt-2">
                <div className="text-sm text-primary text-opacity-70">
                  Password
                </div>
                <div className="relative">
                  <Lock className="absolute top-1.5 left-2" fill="white" />
                  {hidden ? (
                    <VisibilityOff
                      className="cursor-pointer absolute top-1.5 right-2"
                      fill="white"
                      onClick={() => {
                        setHidden(false);
                      }}
                    />
                  ) : (
                    <Visibility
                      className="cursor-pointer absolute top-1.5 right-2"
                      fill="white"
                      onClick={() => {
                        setHidden(true);
                      }}
                    />
                  )}
                  <input
                    type={hidden ? "password" : "text"}
                    className={
                      "px-3 py-1.5 rounded-lg w-full text-white bg-secondary bg-opacity-70 pl-10 focus:outline-none focus:bg-opacity-90 "
                    }
                    name="password"
                    autoComplete={"new-password"}
                    value={state.password}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="mt-8">
                <Button
                  className={
                    "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 uppercase " +
                    (loading ? "cursor-wait" : "")
                  }
                  handleClick={handleNext}
                  disabled={loading}
                >
                  Next
                </Button>

                <Button
                  className={
                    "mt-3 tracking-widest w-full border border-secondary text-primary rounded-lg px-3 py-2 uppercase " +
                    (loading ? "cursor-wait" : "")
                  }
                  handleClick={() => setStep(0)}
                  disabled={loading}
                >
                  Back
                </Button>
              </div>

              {/* <div className="mt-3">
                <p className="text-sm ">
                  Sudah punya akun?
                  <Link to="/login">
                    <span className="ml-1 text-primary cursor-pointer">
                      Login Sekarang
                    </span>
                  </Link>
                </p>
              </div>
              <br /> */}
            </div>

            {/* STEP 2 */}
            {
              (isPatient &&
                <div
                  className={
                    "w-full absolute transition-all duration-500 ease-in-out " +
                    (step === 2
                      ? "opacity-100 left-0 z-10"
                      : "opacity-0  -left-5 z-0")
                  }
                >


                  <div className="mt-2">
                    <div className="text-sm text-primary text-opacity-70">
                      Tinggi Badan (cm)
                    </div>
                    <div className="relative">
                      {/* <VerifiedUser
                        className="absolute top-1.5 left-2"
                        fill="white"
                      /> */}
                      <input
                        type="number"
                        className={
                          "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70  text-white focus:outline-none focus:bg-opacity-90 "
                        }
                        name="tinggi"
                        value={state2.height}
                        onChange={handleChange2}
                        disabled={loading}
                        min={VAR_LIMIT.weight.min}
                        max={VAR_LIMIT.weight.max}
                      />
                    </div>
                  </div>

                  <div className="mt-2">
                    <div className="text-sm text-primary text-opacity-70">
                      Berat Badan (Kg)
                    </div>
                    <div className="relative">
                      {/* <WorkBlack className="absolute top-1.5 left-2" fill="white" /> */}
                      <input
                        type="number"
                        className={
                          "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70  text-white focus:outline-none focus:bg-opacity-90 "
                        }
                        name="berat"
                        value={state2.weight}
                        onChange={handleChange2}
                        disabled={loading}
                        min={VAR_LIMIT.weight.min}
                        max={VAR_LIMIT.weight.max}
                      />
                    </div>
                  </div>

                  <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                    <div className="col-span-12 sm:col-span-3">Tanggal Lahir</div>
                    <InputText
                      type="date"
                      className="col-span-12 sm:col-span-9"
                      placeholder="yyyy-mm-dd"
                      name="dateOfBirth"
                      value={state2.dateOfBirth}
                      onChange={handleChange2}
                      max={maxDate}
                      min={minDate}
                    />
                  </div>

                  <div className="mt-2">
                    <div className="text-sm text-primary text-opacity-70">
                      Jenis Kelamin
                    </div>
                    <div className="relative">
                      {/* <People className="absolute top-1.5 left-2" fill="white" /> */}
                      <select
                        className={
                          "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 text-white focus:outline-none focus:bg-opacity-90 "
                        }
                        // style={{ textIndent: "2.2rem" }}
                        name="sex"
                        value={state2.sex}
                        onChange={handleChange2}
                        disabled={loading}
                      >
                        <option value="Pria">Pria</option>
                        <option value="Wanita">Wanita</option>
                      </select>
                    </div>
                  </div>

                  <div className="mt-8">
                    <Button
                      className={
                        "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 uppercase " +
                        (loading ? "cursor-wait" : "")
                      }
                      handleClick={handleSignup2}
                      disabled={loading}
                    >
                      Signup
                    </Button>
                    <Button
                      className={
                        "mt-3 tracking-widest w-full border border-secondary text-primary rounded-lg px-3 py-2 uppercase " +
                        (loading ? "cursor-wait" : "")
                      }
                      handleClick={() => setStep(1)}
                      disabled={loading}
                    >
                      Back
                    </Button>
                  </div>
                </div>)
              ||
              <div
                className={
                  "w-full absolute transition-all duration-500 ease-in-out " +
                  (step === 2
                    ? "opacity-100 left-0 z-10"
                    : "opacity-0  -left-5 z-0")
                }
              >
                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Kategori
                  </div>
                  <div className="relative">
                    <People className="absolute top-1.5 left-2" fill="white" />
                    <select
                      className={
                        "pr-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 text-white focus:outline-none focus:bg-opacity-90 "
                      }
                      style={{ textIndent: "2.2rem" }}
                      name="role"
                      value={state.role}
                      onChange={handleChange}
                      disabled={loading}
                    >
                      <option value="health worker">Tenaga Kesehatan</option>
                      <option value="doctor">Dokter</option>
                    </select>
                  </div>
                </div>

                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Tempat Praktek
                  </div>
                  <div className="relative">
                    <WorkBlack className="absolute top-1.5 left-2" fill="white" />
                    <input
                      type="text"
                      className={
                        "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                      }
                      name="workingPlace"
                      value={state.workingPlace}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Nomor STR
                  </div>
                  <div className="relative">
                    <VerifiedUser
                      className="absolute top-1.5 left-2"
                      fill="white"
                    />
                    <input
                      type="text"
                      className={
                        "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                      }
                      name="strNumber"
                      value={state.strNumber}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="mt-8">
                  <Button
                    className={
                      "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 uppercase " +
                      (loading ? "cursor-wait" : "")
                    }
                    handleClick={handleSignup}
                    disabled={loading}
                  >
                    Signup
                  </Button>
                  <Button
                    className={
                      "mt-3 tracking-widest w-full border border-secondary text-primary rounded-lg px-3 py-2 uppercase " +
                      (loading ? "cursor-wait" : "")
                    }
                    handleClick={() => setStep(1)}
                    disabled={loading}
                  >
                    Back
                  </Button>
                </div>
              </div>
            }

          </form>
        </div>

        <div className="text-xs md:text-sm text-center absolute bottom-3 inset-x-0">
          <p>Copyright &copy; 2021</p>
          <p>PT. Xirka Dama Persada</p>
        </div>
      </section>

      <HeroLogin />
    </div>
  );
};

export default Signup;
